// extracted by mini-css-extract-plugin
export default {"clearfix":"index_clearfix_ICAXk","box_06_title":"index_box_06_title_-1A9m","more":"index_more_rsPqz","title_word":"index_title_word_z4lho"};